import { Vue, Component } from 'vue-property-decorator';
import template from './no-results-item.vue';

@Component({
  mixins: [template],
})
export default class NoResultsItem extends Vue {}
